var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewProductSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6841_26795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8874 8.0344L13.93 5.04492L4.1813 14.7937L3.18213 18.7926L7.18109 17.7923L16.8874 8.0344Z",
    stroke: "#08081B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9302 5.04205L15.3957 3.57653C15.5129 3.45822 15.6524 3.36431 15.8061 3.30022C15.9598 3.23612 16.1246 3.20312 16.2912 3.20312C16.4577 3.20312 16.6226 3.23612 16.7763 3.30022C16.93 3.36431 17.0694 3.45822 17.1866 3.57653L19.2491 5.66424L16.8876 8.03382",
    stroke: "#08081B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53174 14.4492L7.53153 17.449",
    stroke: "#08081B",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6841_26795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProductSvg);
export default __webpack_public_path__ + "static/media/NewProductSvg.5e2a54734ee2fd29d556d75c04102474.svg";
export { ForwardRef as ReactComponent };